export default {
  welcome: 'Welcome',
  form: {
    first_name: 'Primer Nombre',
    middlename: 'Segundo Nombre',
    last_name: 'Apellidos',
    email: 'Correo electrónico',
    mobile_phone: 'Celular',
    phone_length: '10 caracteres exactamente',
    birthday: 'Fecha de Nacimiento',
    clave: 'Código',
    address_1: 'Dirección 1',
    address_2: 'Dirección 2',
    city: 'Ciudad',
    state: 'Estado',
    postcode: 'ZIP Código Postal',
    zip_minlength: '5 caracteres al menos',
    password: 'Contraseña',
    coupon: 'Ingresa el Cupón',
    age: 'Edad',
    relationship: 'Parentesco',
    birthcountry: 'País de Nacimiento',
    birthstate: 'Estado de nacimiento',
    civilState: 'Estado Civil',
    gender: 'Género',
    areacode: 'Código Area',
    homephone: 'Número Casa',
    ssn: 'Número de Seguridad Social',
    idexternal: 'Identificación Extranjero',
    driverlicense: 'Licencia de Conducir',
    changeadress: 'Si requieres completar tu dirección podemos ayudarte ingresando tu ubicación aquí. Maps',
    send: 'Enviar',
    reset: 'Borrar',
    required: 'Este campo es obligatorio',
    addFamDisc: 'Al hacer clic en el botón Agregar, aceptas que la información aquí proveída es correcta y precisa. Hispano Club y los Terceros proveedores de servicios podrán negarse a prestar este servicio si cualquiera de las declaraciones son falsas, fraudulentas, negligentes, incompletas o engañosas de manera alguna.'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es/index.js